<!--jt80页面-->
<template>
    <div>
        <div>

            <van-sticky><!-- 粘性布局，顶部的位置固定 -->
                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">

                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="18">
                            <!-- 搜索组件 -->
                            <form action="/">
                                <van-search
                                        style="width: 100%;"
                                        v-model="keywordFilter"
                                        placeholder="车牌号\车架号\主机号"
                                        show-action
                                        @search="onFind"
                                >
                                    <div slot="action" @click="onFind">搜索</div>
                                </van-search>
                            </form>
                        </van-col>
                        <van-col span="3">
                            <div style="padding: 17px">
                                <!-- icon图标，刷新页面 -->
                                <van-icon name="replay" size="15px" @click="reststart"/>
                            </div>
                        </van-col>
                    </van-row>

                </div>
            </van-sticky>
        </div>


        <div style="background-color: #f8f8f9">

                    <!-- 加载图标 -->
                    <van-loading class="loader" v-if="loader"/>

                    <div v-for="(item,index) in jt808deviceslist" class="content">
                        <Card style="width:100%">
                            <div class="mid">
                                <span class="count fl">系统车牌号:
                                    <label style="color: #0077aa;">{{item.registrationNum}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">设备上报车牌号:
                                    <label style="color: #0077aa;">{{item.collectRegistrationNo}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                <span class="distance fr" style="padding: 5px;">|</span>
                                <span class="time fr">采集车架号:
                                    <label style="color: #0077aa;">{{item.collectVin}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">最后接收时间:
                                    <label style="color: #0077aa;">{{item.lastRecvDatetime==null?'':new Date(item.lastRecvDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>
                                </span>
                                <br>
                                <span class="time fr">最后定位时间:
                                    <label style="color: #0077aa;">{{item.lastLocateDatetime==null?'':new Date(item.lastLocateDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">状态:
                                    <label style="color: #0077aa;">{{item.state==2?'行驶':item.state==1?'熄火':item.state==3?'停车未熄火':'离线'}}</label>
                                </span>
                                <span class="distance fr" style="padding: 5px;">|</span>
                                <span class="time fl">终端型号:
                                    <label style="color: #7f00e2;">{{item.terminalModel == null?'无':item.terminalModel}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">
                                    主机号:
<!--                                    <label style="color: #0077aa;">{{item.terminalNum}}</label>-->
                                <Button type="primary" @click="onJt808MonitoringViewModal(item)" size="small">{{item.terminalNum}}</Button>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{item.collectEngineNum}}</label>
                                </span>
                                <br>
                                <span class="time fr">车牌分类:
                                    <label style="color: #0077aa;">{{item.collectVehicleType}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">无线通信网络信号强度:
                                    <label style="color: #0077aa;">{{item.rssi}}</label>
                                </span>
                                <span class="distance fr" style="padding: 5px;">|</span>
                                <span class="time fr">定位卫星数:
                                    <label style="color: #0077aa;">{{item.gnssCount}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">启用GPS:
                                    <label style="color: #0077aa;">{{item.gpsEnable?'是':'否'}}</label>
                                </span>
                                <span class="distance fr" style="padding: 5px;">|</span>
                                <span class="time fr">启用北斗:
                                    <label style="color: #0077aa;">{{item.beidouEnable?'是':'否'}}</label>
                                </span>
                                <br>
                                <span class="count fl">启用Galileo:
                                    <label style="color: #0077aa;">{{item.galileoEnable?'是':'否'}}</label>
                                </span>
                                <span class="distance fr" style="padding: 5px;">|</span>
                                <span class="time fr">启用Glonass:
                                    <label style="color: #0077aa;">{{item.glonassEnable?'是':'否'}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">司机卡号:
                                    <label style="color: #0077aa;">{{item.collectDriverCardNum}}</label>
                                </span>
                                <span class="distance fr" style="padding: 5px;">|</span>
                                <span class="time fr">驾驶员名:
                                    <label style="color: #0077aa;">{{item.collectDriverName}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">驾驶证号:
                                    <label style="color: #0077aa;">{{item.collectDriverLicenseNum}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">采集信息:
                                    <label style="color: #0077aa;">{{item.collectText}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">采集时间:
                                    <label style="color: #0077aa;">{{item.collectDatetime==null?'':new Date(item.collectDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="time fr">实时驾驶员名:
                                    <label style="color: #0077aa;">{{item.driverName}}</label>
                                </span>
                                <span class="distance fr">|</span>
                                <span class="count fl">司机卡更新时间:
                                    <label style="color: #0077aa;">{{item.driverCardReportDatetime==null?'':new Date(item.driverCardReportDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">实时驾驶证号:
                                    <label style="color: #0077aa;">{{item.driverLicenseNum}}</label>
                                </span>
                            </div>

                            <van-collapse class="next" v-model="activeName">
                                <van-collapse-item class="next1" :name=index>

                                    <div class="mid">
                                        <van-button size="small" type="info" @click="onSendCommandModal(item)">发送指令
                                        </van-button>&nbsp;&nbsp;
                                        <van-button size="small" type="info" @click="RestartTerminal(item)">重启终端
                                        </van-button>&nbsp;&nbsp;
                                    </div>

                                    <div class="mid">
                                        <van-button size="small" type="info" @click="onupVehicleParamsModal(item)">写卡设置
                                        </van-button>&nbsp;&nbsp;
                                        <van-button size="small" type="info" @click="onSelectSendTerminalParametersModal(item)">设置终端参数
                                        </van-button>&nbsp;&nbsp;
                                    </div>

                                </van-collapse-item>
                            </van-collapse>



                        </Card>
                        <div style="height: 3px"></div>
                        <!-- 分割线组件 -->
                        <!--                <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
                        <!--                </van-divider>-->
                    </div>


        </div>
<!--发送指令-->
        <Modal v-model="showSendCommandModal" width="600" title="发送指令">
            <Form ref="sendCommand" autoComplete="on" v-model="sendCommand"
                  class="card-box login-form">
                <Form-item label="指令内容">
                    <Input v-model="sendCommand.content" placeholder="指令内容"></Input>
                </Form-item>
                <Checkbox v-model="sendCommand.urgent">紧急</Checkbox>
                <Button type="primary" @click="onSendCommand">发送</Button>
            </Form>
        </Modal>

        <Modal v-model="setupReportIntervalModal" width="600" title="汇报间隔">
            <Form ref="setupReportInterval" autoComplete="on" v-model="setupReportInterval"
                  class="card-box login-form">
                <FormItem prop="driverCardNum">
                    <label style="display: inline-block; width: 100px;">ACC开上传间隔</label>
                    <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;"
                                 v-model="setupReportInterval.accOn" placeholder="请输入ACC开上传间隔">
                    </InputNumber>
                </FormItem>
                <FormItem prop="driverLicenseNum">
                    <label style="display: inline-block; width: 100px;">ACC关上传间隔</label>
                    <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;"
                                 v-model="setupReportInterval.accOff" placeholder="请输入ACC关上传间隔">
                    </InputNumber>
                </FormItem>
                <Button type="primary" @click="onSetupReportInterval">发送</Button>
            </Form>
        </Modal>

    <select-send-command-modal v-model="selectSendCommandModal" :initValue="selectSendCommandId" :installed="selectSendCommandTrationNum"></select-send-command-modal>
        <select-send-terminal-parameters-modal  v-model="selectSendTerminalParametersModal" :initValue="selectSendTerminalParametersId" :installed="selectSendTerminalParametersTrationNum"></select-send-terminal-parameters-modal>
        <jt808-monitoring-view-modal ref="Jt808MonitoringViewModalRef" v-model="jt808MonitoringViewModal" :initValue="jt808MonitoringViewId" :jt808MonitoringViewterminalNum="jt808MonitoringViewterminalNum"></jt808-monitoring-view-modal>

    </div>
</template>

<script>
    import SelectSendCommandModal from '@/views/ddm/components/select-send-command-modal'
    import SelectSendTerminalParametersModal from '@/views/ddm/components/select-send-terminal-parameters-modal'
    import Jt808MonitoringViewModal from '@/views/ddm/components/jt808-monitoring-view-modal'


    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    function getWordsCount (val) {
        var bytesCount = 0
        for (var i = 0; i < val.length; i++) {
            var c = val.charAt(i)
            if (/^[\u0000-\u00ff]$/.test(c)) // 匹配双字节
            {
                bytesCount += 1
            } else {
                bytesCount += 2
            }
        }
        return bytesCount
    }

    export default {
        name: "jt808-devices",
        components: {
            SelectSendCommandModal,
            SelectSendTerminalParametersModal,
            Jt808MonitoringViewModal,
        },
        data(){
            return{
                loader: false,
                activeName: [],

                keywordFilter:null,
                jt808deviceslist:[],

                //选择写卡生产商
                selectSendCommandModal:false,
                selectSendCommandId:null,//JT808id
                selectSendCommandTrationNum:null,//主机号

                //设置终端参数
                selectSendTerminalParametersModal:false,
                selectSendTerminalParametersId:null,//JT808id
                selectSendTerminalParametersTrationNum:null,//主机号

                /**
                 * 发送指令
                 */
                showSendCommandModal: false,
                sendCommand: {
                    id: 0,
                    content: null,
                    urgent:true
                },
                /**
                 * 汇报间隔
                 */
                setupReportIntervalModal: false,
                setupReportInterval: {
                    id: null,
                    accOn: 15,
                    accOff: 120
                },

                // 实时监控组件
                jt808MonitoringViewModal: false,
                jt808MonitoringViewId: null,
                jt808MonitoringViewterminalNum: null,
            }
        },
        mounted() {
            setInterval(this.reststart, 10000)
if (this.keywordFilter!=null){
            // setInterval(this.setpage,5000)
}
            // let sortParam = null
            //
            // if (this.sort !== null && this.sort !== undefined) {
            //     sortParam = genSortParam(this.sort.name, this.sort.asc)
            // } else {
            //     sortParam = genSortParam('id', false)
            // }
            //
            // store.dispatch('Jt808DeviceServ_GetPage', {
            //     params: null,
            //     urlparams: {
            //         p: 1,
            //         keyword: this.keywordFilter,
            //         sort: sortParam
            //     }
            // }).then(res => {
            //     this.jt808deviceslist=res.data.content
            // }).catch(err => {
            //     this.$Message.error(err)
            // })

        },
        methods:{
            onupVehicleParamsModal(e){
                this.selectSendCommandId=e.id
                this.selectSendCommandModal=true
                this.selectSendCommandTrationNum = e.terminalNum
            },
            onSelectSendTerminalParametersModal(e){
                this.selectSendTerminalParametersId =e.id
                this.selectSendTerminalParametersModal=true
                this.selectSendTerminalParametersTrationNum = e.terminalNum
            },
            onSetupReportInterval () {
                store.dispatch('NetCommandServ_SetupReportInterval', {
                    params: this.setupReportInterval
                }).then(() => {
                    this.$Message.success('发送成功')
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            RestartTerminal(e){
                // console.log(e)
                store.dispatch('NetCommandServ_Restart', {
                    params: { id: e.id }
                }).then(() => {
                    this.$Message.success('发送成功')
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            onSendCommandModal(e){
                console.log(e.id)
                this.sendCommand.id=e.id
                this.showSendCommandModal=true
            },
            onSendCommand () {
                store.dispatch('NetCommandServ_SendCommand', {
                    params: this.sendCommand
                }).then(() => {
                    this.$Message.success('发送成功')
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            onFind(){
                this.setpage()
            },
            setpage(){
                let sortParam = null

                if (this.sort !== null && this.sort !== undefined) {
                    sortParam = genSortParam(this.sort.name, this.sort.asc)
                } else {
                    sortParam = genSortParam('id', false)
                }
                    this.onData(sortParam)
            },
            onData(sortParam){
                this.jt808deviceslist=[]
                store.dispatch('Jt808DeviceServ_GetPage', {
                    params: null,
                    urlparams: {
                        keyword: this.keywordFilter,
                        sort: sortParam
                    }
                }).then(res => {
                    // this.jt808deviceslist=res.data.content
                    for (let i = 0; i < res.data.content.length; i++) {
                        this.jt808deviceslist.push(res.data.content[i])
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            // <!-- icon图标刷新方法 -->
            reststart() {
                this.loader = true
                setTimeout(() => {
                    this.setpage()
                    this.loader = false
                }, 500);
            },
            onJt808MonitoringViewModal(device){
                this.jt808MonitoringViewModal = true
                this.jt808MonitoringViewId = device.id
                this.jt808MonitoringViewterminalNum = device.terminalNum
            }
        },
    }
</script>

<style scoped>
    .s1 {
        color: blue;
    }

    .s2 {
        color: yellowgreen;
    }

    .s3 {
        color: blueviolet;
    }

    .s4 {
        color: red;
    }


    /*右侧内容*/
    .content {
        /*background-color: red;*/
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 15px 0 10px;
    }

    .content .name {
        font-size: 17px;
        color: #333;
        overflow: hidden;
        font-weight: bold;
        overflow: hidden;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

    .conopen {
        text-align: right;
    }

    .loader {
        text-align: center;
    }

    .wrapper {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 115px;
        bottom: 50px; /*关键*/
        overflow: hidden;
        z-index: 1;
    }
</style>
